import getUuid from 'widget/helpers/uuid';

/**
 * Builds authorization headers with idempotency key for InboxMW API requests.
 * Use this for POST, PATCH, DELETE requests to /inboxmw/ endpoints.
 * @param {string} token - The JWT access token
 * @returns {Object} Headers object with Authorization and Idempotency-Key
 */
export function buildIdempotentHeaders(token) {
  return {
    Authorization: `Bearer ${token}`,
    'Idempotency-Key': getUuid(),
  };
}
